// Géolocalisation et distance

const USE_MOCK_GEOCODE = false; // passez à true si Nominatim est bloqué en dev

const MOCK_CITY_TO_COORDS = {
  // Exemples pour dev
  Villebarou: { lat: 47.614, lon: 1.327 },
  Blois: { lat: 47.593, lon: 1.327 },
  Paris: { lat: 48.8566, lon: 2.3522 },
  Orléans: { lat: 47.9022, lon: 1.9046 },
};

// Cache pour éviter les géocodages répétés
const GEOCODE_CACHE = new Map();

export async function geocodeAddress(address) {
  if (USE_MOCK_GEOCODE) {
    // Recherche simple par ville dans la chaîne
    for (const city of Object.keys(MOCK_CITY_TO_COORDS)) {
      if (address.toLowerCase().includes(city.toLowerCase())) {
        return MOCK_CITY_TO_COORDS[city];
      }
    }
    throw new Error("Adresse introuvable (mock)");
  }

  // Vérifier le cache d'abord
  const cacheKey = address.toLowerCase().trim();
  if (GEOCODE_CACHE.has(cacheKey)) {
    console.log('🚀 Cache hit pour:', address);
    return GEOCODE_CACHE.get(cacheKey);
  }

  try {
    // Nettoyer et optimiser l'adresse
    const cleanAddress = address
      .replace(/\s+/g, ' ') // Remplacer les espaces multiples par un seul
      .trim();
    
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanAddress)}&limit=1&addressdetails=1&countrycodes=fr`;
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // Timeout de 5s
    
    const res = await fetch(url, {
      headers: { 
        Accept: "application/json",
        'User-Agent': 'CovoiturageApp/1.0' // Éviter les blocages
      },
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    
    const data = await res.json();
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error("Adresse introuvable");
    }
    
    const first = data[0];
    const result = { 
      lat: parseFloat(first.lat), 
      lon: parseFloat(first.lon) 
    };
    
    // Valider les coordonnées
    if (isNaN(result.lat) || isNaN(result.lon)) {
      throw new Error("Coordonnées invalides");
    }
    
    // Mettre en cache
    GEOCODE_CACHE.set(cacheKey, result);
    console.log('✅ Géocodage réussi et mis en cache:', address, '→', result);
    
    return result;
    
  } catch (error) {
    console.warn('⚠️ Erreur géocodage pour:', address, error.message);
    throw error;
  }
}

export function haversineKm(a, b) {
  const R = 6371; // km
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.asin(Math.sqrt(h));
  return R * c;
}

export function formatKm(d) {
  const rounded = Math.round(d * 10) / 10;
  return `${rounded.toString().replace(".", ",")} km`;
}
